import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useState, useEffect } from 'react';
import ProductTable from './elements';
import { Button } from '../../elements/trustyle-button';
import DropDown from '../../elements/drop-down';
import { TruMoneyFilter, TruSort } from '@uswitch/spark-icons/tru';
import SlideReveal from '../../elements/slide-reveal';
import { getValue, getField, getDisabledValue } from './utils';
import Image from '../../elements/imgix-img';
import Addons from './addons';
import Cell from './cell';
import Badges from './badges';
import Calculator from './calculator';
import Filter from './filters';
import LoadingState from '../loading-state';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";
import { Fragment as _Fragment } from "theme-ui/jsx-runtime";

var PT = function PT(_ref) {
  var _sorts$selectable, _getSortByObj;

  var _ref$data = _ref.data,
      data = _ref$data === void 0 ? [] : _ref$data,
      _ref$header = _ref.header,
      header = _ref$header === void 0 ? {} : _ref$header,
      _ref$grid = _ref.grid,
      grid = _ref$grid === void 0 ? {
    contents: []
  } : _ref$grid,
      addons = _ref.addons,
      _ref$sorts = _ref.sorts,
      sorts = _ref$sorts === void 0 ? {} : _ref$sorts,
      _ref$filters = _ref.filters,
      filters = _ref$filters === void 0 ? [] : _ref$filters,
      maxPerPage = _ref.maxPerPage,
      _ref$calculator = _ref.calculator,
      calculator = _ref$calculator === void 0 ? {} : _ref$calculator,
      totalHits = _ref.totalHits,
      _ref$offset = _ref.offset,
      offset = _ref$offset === void 0 ? 0 : _ref$offset,
      extras = _ref.extras,
      onSort = _ref.onSort,
      onFilter = _ref.onFilter,
      onPagination = _ref.onPagination,
      onCalculate = _ref.onCalculate,
      calcModalContent = _ref.calcModalContent,
      clickableRow = _ref.clickableRow,
      loadingLabel = _ref.loadingLabel,
      _ref$settings = _ref.settings,
      settings = _ref$settings === void 0 ? {} : _ref$settings,
      _ref$calculatorInputs = _ref.calculatorInputs,
      calculatorInputs = _ref$calculatorInputs === void 0 ? {} : _ref$calculatorInputs,
      onClickEligibility = _ref.onClickEligibility,
      _ref$card = _ref.card,
      card = _ref$card === void 0 ? false : _ref$card;

  var _ref2 = calculator || {},
      isCalculatorAlwaysOpen = _ref2.isAlwaysVisible;

  var sortOptions = sorts && sorts.selectable && sorts.selectable.length ? [{
    value: '',
    text: 'Sort by'
  }].concat(_toConsumableArray(sorts.selectable.map(function (sort) {
    return {
      value: getField(sort.value),
      text: sort.label
    };
  }))) : [];

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      filterOpen = _useState4[0],
      setFilterOpen = _useState4[1];

  var _useState5 = useState(!!isCalculatorAlwaysOpen),
      _useState6 = _slicedToArray(_useState5, 2),
      calculatorOpen = _useState6[0],
      setCalculatorOpen = _useState6[1];

  var _useState7 = useState(function () {
    if (!filters) {
      return [];
    }

    return filters.map(function (filter) {
      return {
        label: filter.label,
        type: filter.type,
        options: filter.options.map(function (option) {
          return {
            label: option.label,
            value: filter.type === 'dropdown' ? filter.options.indexOf(option) === 0 : false
          };
        })
      };
    });
  }),
      _useState8 = _slicedToArray(_useState7, 2),
      filterBy = _useState8[0],
      setFilterBy = _useState8[1];

  var _useState9 = useState(offset),
      _useState10 = _slicedToArray(_useState9, 2),
      pageOffset = _useState10[0],
      setPageOffset = _useState10[1];

  var defaultSort = ((_sorts$selectable = sorts.selectable) === null || _sorts$selectable === void 0 ? void 0 : _sorts$selectable.find(function (sort) {
    return sort.default;
  })) || {};

  var _useState11 = useState(getField(defaultSort.value) || ''),
      _useState12 = _slicedToArray(_useState11, 2),
      sortBy = _useState12[0],
      setSortByState = _useState12[1];

  useEffect(function () {
    setPageOffset(offset);
  }, [offset]);

  var setSortBy = function setSortBy(sortBy) {
    if (!sortBy) return;
    setSortByState(sortBy);

    if (typeof onSort === 'function' && sortBy) {
      var sortByObj = getSortByObj(sortBy);

      if (sortByObj) {
        setIsLoading(true);
        var maybePromise = onSort(sortByObj);
        Promise.resolve(maybePromise).then(function () {
          setPageOffset(0);
          setIsLoading(false);
        });
      }
    }
  };

  var getSortByObj = function getSortByObj(sortBy) {
    var _sorts$selectable2;

    return (_sorts$selectable2 = sorts.selectable) === null || _sorts$selectable2 === void 0 ? void 0 : _sorts$selectable2.find(function (_ref3) {
      var value = _ref3.value;
      return getField(value) === sortBy;
    });
  };

  var handleFilterClick = function handleFilterClick() {
    setIsLoading(true);
    var maybePromise = onFilter(filterBy);
    Promise.resolve(maybePromise).then(function () {
      setFilterOpen(false);
      setPageOffset(0);
      setIsLoading(false);
    });
  };

  var handlePaginationClick = function handlePaginationClick() {
    setIsLoading(true);
    var maybePromise = onPagination(pageOffset);
    Promise.resolve(maybePromise).then(function () {
      setPageOffset(pageOffset + maxPerPage);
      setIsLoading(false);
    });
  };

  var handleCalculatorClick = function handleCalculatorClick(data) {
    setCalculatorOpen(!calculatorOpen);
    setIsLoading(true);
    var maybePromise = onCalculate(data);
    Promise.resolve(maybePromise).then(function () {
      setCalculatorOpen(false);
      setPageOffset(0);
      setIsLoading(false);
    });
  };

  var handleFilterButton = function handleFilterButton() {
    setCalculatorOpen(false);
    setFilterOpen(!filterOpen);
  };

  var handleCalculatorButton = function handleCalculatorButton() {
    setFilterOpen(false);
    setCalculatorOpen(!calculatorOpen);
  };
  /** =============
   * Mortgage-specific code
   * We need to display LTV for mortgages in the compliance text, and the only way to do it is to plug it here.
   * This code also allows to refer calculator field values in the compliance text if needed
   */


  var ltv = 'NONE';
  var propertyValue = parseInt(calculatorInputs.propertyValue, 10);
  var mortgageAmount = parseInt(calculatorInputs.mortgageAmount, 10);

  if (propertyValue && mortgageAmount) {
    ltv = "".concat(Math.floor(mortgageAmount / propertyValue * 100), "%");
  }

  var calculatorReplaceFields = _objectSpread(_objectSpread({}, calculatorInputs), {}, {
    ltv: ltv
  }); // ==============


  var replaceObject = _objectSpread({
    resultCount: totalHits,
    resultOrResults: totalHits === 1 ? 'result' : 'results',
    sortBy: ((_getSortByObj = getSortByObj(sortBy)) === null || _getSortByObj === void 0 ? void 0 : _getSortByObj.label.toLowerCase()) || sortBy,
    complianceLink: extras === null || extras === void 0 ? void 0 : extras.complianceLink
  }, calculatorReplaceFields);

  var complianceText = extras && extras.complianceText && extras.complianceText.replace(/\$\{([a-z]+)\}/gi, function (original, match) {
    return match in replaceObject ? replaceObject[match] : original;
  });
  var calculatorButtonColor = calculatorOpen ? 'grey-05' : 'none';
  var loadingStateBackgroundColour = isLoading ? 'opaque-plum-01' : 'inherit';
  return _jsxs(_Fragment, {
    children: [complianceText || filterBy.length && onFilter || sortOptions.length && onSort ? _jsxs("div", {
      sx: {
        display: [null, 'flex'],
        alignItems: 'center',
        justifyContent: 'flex-end',
        paddingBottom: 9,
        variant: 'compounds.product-table.variants.ordering.second'
      },
      children: [complianceText ? _jsx("div", {
        sx: {
          marginRight: 'auto',
          fontSize: 'xs'
        },
        dangerouslySetInnerHTML: {
          __html: complianceText
        }
      }) : null, filterBy.length && onFilter || sortOptions.length && onSort || calculator && onCalculate && calculator.steps ? _jsxs("div", {
        sx: {
          display: 'flex',
          flexShrink: 0,
          marginLeft: [null, 'md'],
          marginTop: ['sm', 0]
        },
        children: [filterBy.length && onFilter ? _jsx("div", {
          sx: {
            display: 'inline-block',
            marginRight: sortOptions.length && onSort ? 'sm' : null
          },
          children: _jsxs(Button, {
            variant: "control",
            sx: {
              fontSize: 'xs',
              whiteSpace: 'nowrap'
            },
            onClick: function onClick() {
              return handleFilterButton();
            },
            children: [_jsx("div", {
              sx: {
                display: 'inline-block',
                width: '1em',
                marginRight: 'xs'
              },
              children: _jsx(TruMoneyFilter, {
                color: "fuschia"
              })
            }), "Filter"]
          })
        }) : null, !isCalculatorAlwaysOpen && calculator && onCalculate && calculator.steps ? _jsx("div", {
          sx: {
            display: 'inline-block',
            marginRight: sortOptions.length && onSort ? 'sm' : null
          },
          children: _jsxs(Button, {
            variant: "control",
            sx: {
              fontSize: 'xs',
              whiteSpace: 'nowrap',
              backgroundColor: calculatorButtonColor
            },
            onClick: function onClick() {
              return handleCalculatorButton();
            },
            children: [_jsx("div", {
              sx: {
                display: 'inline-block',
                width: '1em',
                marginRight: 'xs'
              },
              children: _jsx(TruMoneyFilter, {
                color: "fuschia"
              })
            }), "Change loan amount"]
          })
        }) : null, sortOptions.length && onSort ? _jsx("div", {
          sx: {
            display: 'inline-block'
          },
          children: _jsx(DropDown, {
            name: "sorts",
            onBlur: function onBlur() {},
            onChange: function onChange(val) {
              return setSortBy(val);
            },
            options: sortOptions,
            value: sortBy,
            overlay: _jsxs("span", {
              children: [_jsx("div", {
                sx: {
                  display: 'inline-block',
                  width: '1em',
                  marginRight: 'xs'
                },
                children: _jsx(TruSort, {
                  color: "fuschia"
                })
              }), "Sort by"]
            }),
            sx: {
              borderColor: 'grey-20',
              fontSize: 'xs'
            }
          })
        }) : null]
      }) : null]
    }) : null, filterBy.length && onFilter ? _jsx(SlideReveal, {
      open: filterOpen,
      children: _jsx(Filter, {
        filterBy: filterBy,
        setFilterBy: setFilterBy,
        handleFilterClick: handleFilterClick,
        setFilterOpen: setFilterOpen
      })
    }) : null, calculator && onCalculate && calculator.steps ? _jsx("div", {
      sx: {
        variant: 'compounds.product-table.variants.ordering.first'
      },
      children: _jsx(SlideReveal, {
        open: calculatorOpen,
        children: _jsx(Calculator, {
          calculator: calculator,
          submit: handleCalculatorClick,
          modalContent: calcModalContent
        })
      })
    }) : null, isLoading ? _jsx(LoadingState, {
      label: loadingLabel
    }) : null, _jsxs("div", {
      sx: {
        position: 'relative'
      },
      children: [isLoading ? _jsx("div", {
        sx: {
          position: 'absolute',
          backgroundColor: loadingStateBackgroundColour,
          zIndex: '1',
          width: '100%',
          height: '100%'
        }
      }) : null, data.map(function (product, id) {
        return _jsx(ProductTable.Row, {
          badges: Badges(product),
          preTitle: getValue(header.kicker, product),
          rowTitle: getValue(header.title, product),
          subtitle: getValue(header.subtitle, product),
          image: header.image && _jsx(ProductTable.cells.HeaderImage, {
            children: _jsx(Image, {
              src: getValue(header.image, product),
              alt: getValue(header.alt, product)
            })
          }, "".concat(product.id, "-img")),
          addons: Addons(addons, product, onClickEligibility),
          clickableRow: getValue(clickableRow, product),
          disabled: getDisabledValue(settings.disablingField, product),
          card: card,
          children: grid.contents.map(function (cell, key) {
            return Cell(cell.type, {
              key: key,
              cell: cell,
              data: product,
              headerImage: header.image
            });
          }, this)
        }, product.id);
      }, this)]
    }), totalHits > maxPerPage && totalHits > pageOffset && maxPerPage !== 0 ? _jsx("div", {
      sx: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: 'md'
      },
      children: _jsx(Button, {
        variant: "primary",
        onClick: handlePaginationClick,
        disabled: isLoading,
        children: isLoading ? 'Loading' : "Load ".concat(maxPerPage, " More")
      })
    }) : null]
  });
};

export default PT;
//# sourceMappingURL=product-table.js.map